import { render, staticRenderFns } from "./comanswer.vue?vue&type=template&id=ac488a32&scoped=true"
import script from "./comanswer.vue?vue&type=script&lang=js"
export * from "./comanswer.vue?vue&type=script&lang=js"
import style0 from "./comanswer.vue?vue&type=style&index=0&id=ac488a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac488a32",
  null
  
)

export default component.exports